import { render, staticRenderFns } from "./CoordinatorDashboard.vue?vue&type=template&id=38f3a912&scoped=true"
import script from "./CoordinatorDashboard.vue?vue&type=script&lang=ts"
export * from "./CoordinatorDashboard.vue?vue&type=script&lang=ts"
import style0 from "./CoordinatorDashboard.vue?vue&type=style&index=0&id=38f3a912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3a912",
  null
  
)

export default component.exports